import React from 'react';
import { HashRouter, Route } from 'react-router-dom';
import { withTranslations } from 'react-utilities';
import { translationConfig } from './translation.config';
import GamesList from './containers/GamesList';
import SortDetail from '../../../ts/react/sortDetail/SortDetail';
import SortDetailV2 from '../../../ts/react/sortDetail/SortDetailV2';

function App(props) {
  return (
    <HashRouter>
      <Route exact path='/' render={() => <GamesList {...props} />} />
      <Route exact path='/sortName/:sortName' component={SortDetail} />
      <Route exact path='/sortName/v2/:sortName' component={SortDetailV2} />
    </HashRouter>
  );
}

export default withTranslations(App, translationConfig);
